import { filter, some } from "../../common/utils";
import { REWARD_TYPE_PRE, REWARD_TYPE_FINAL } from "../../common/const";


function _getAwards(myAwards, f) {
    const awards =  myAwards ? filter(myAwards, f) : []
    return awards.length > 0 ? awards : null
}

export function myPreAwards(state) {
    return _getAwards(state.myAwards, o => o.rewardType === REWARD_TYPE_PRE)
}

export function myFinalAwards(state) {
    return _getAwards(state.myAwards, o => o.rewardType === REWARD_TYPE_FINAL)
}

export function hasRealityAward(state) {
    const {myAwards} = state
    return myAwards ? some(myAwards, o => o.reality > 0) : false
}

// 是否需要填写地址
export function needAddress(state, getters) {
    const {
        hasRealityAward,
        isAfter,
        finalRes
    } = getters
    if (isAfter(finalRes)) {
        return hasRealityAward
    }
    return false
}

// 是否需要绑定账号
export function needBind(state) {
    const {
        myAwards
    } = state
    return !!myAwards
}
